import { ConfigState } from './types';
import appConfig from '@/config';
import { env } from '@/env';

export default <ConfigState>{
    staticConfig: appConfig,
    localConfig: {},
    values: appConfig,
    apiUrl: env.VUE_APP_CONTENT_API_URL,
};
